import { Component, OnInit } from '@angular/core';
import { DashboardEmployeeService } from '../dashboard-employee/dashboard-employee.service';

@Component({
  selector: 'app-time-sheet-approval-list',
  templateUrl: './time-sheet-approval-list.component.html',
  styleUrls: ['./time-sheet-approval-list.component.css']
})
export class TimeSheetApprovalListComponent implements OnInit {
  public approveList: any = [];
  constructor(private dashboardEmployeeService: DashboardEmployeeService) { }

  ngOnInit() {
    this.getApproveList();
  }

  /**
  * @function getApproveList
  * @description
  * getApproveList is the function to get all the list of the timesheet entry sent for RM for approval
  *  of the particular logged user and display it in the table format for the end user.
  * @var approveList variable to store the list obtained from the backend upon API call
  * @method post
  * @return null
  * @author gaurav.rao
  **/
  getApproveList() {
    this.approveList = [];
    this.dashboardEmployeeService.getEmployeesDetails().subscribe((data) => {
      if (data.payload.unapprovedTimesheet) {
        data.payload.unapprovedTimesheet.map(value => this.approveList.push(value));
      }
      this.approveList.reverse();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/time-sheet-approval-list/time-sheet-approval-list.component.ts